var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Gmail",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158 391v-142l-82-63V361q0 30 30 30",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 154 248l102 77l102-77v-98l-102 77l-102-77",
    fill: "#ea4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M354 391v-142l82-63V361q0 30-30 30",
    fill: "#34a853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76 188l82 63v-98l-30-23c-27-21-52 0-52 26",
    fill: "#c5221f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M436 188l-82 63v-98l30-23c27-21 52 0 52 26",
    fill: "#fbbc04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailSvgrepoCom);
export default __webpack_public_path__ + "static/media/gmail-svgrepo-com.87cc67187afd3477d6c29ef768e48834.svg";
export { ForwardRef as ReactComponent };